<template>
  <div class="column is-12">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3 class="title is-5">Formato de vinculación de clientes</h3>
      </div>
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <div class="column is-12">
          <p>Descarga <a href="https://stilotex-website.s3.amazonaws.com/docs/JU800-FOR32-1+Creacion+y+Registro+Asociados+de+Negocio+Nacional.xlsx" target="_blank">aquí</a> el formato de vinculación de clientes y adjúntalo diligenciado para continuar.</p>
          <p>Recuerda, adjuntar los soportes correspondientes para continuar.</p>
          <div class="dropbox">
            <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                   accept="*" class="input-file">
            <p v-if="isInitial">
              Arrastre los archivos<br> o dar click para adjuntar
            </p>
            <p v-if="isSaving">
              Subiendo {{ fileCount }} archivo(s)...
            </p>
          </div>
        </div>
      </form>
      <div v-if="isSuccess">
        <h2>Los archivo(s) {{ uploadedFiles.length }} se han subido con éxito.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Subir de nuevo</a>
        </p>
        <ul class="list-unstyled">
          <li v-for="item in uploadedFiles">
            <p>{{item.originalName}}</p>
          </li>
        </ul>
        <div class="column is-6">
          <div class="field">
            <button class="button is-black" @click="onSubmit">Enviar</button>
          </div>
        </div>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h2>Uploaded failed.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Intenta de nuevo</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { upload } from  '../../../../services/file-upload.fake.service'; // fake service
// import { upload } from '../../../services/file-upload.service';   // real service

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3
export default {
  name: "VinculationForm",
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos'
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    onSubmit() {
      this.$emit('done', {
        key: 'vinculationForm',
        vinculationForm: this.uploadedFiles
      })
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      upload(formData)
          .then(x => {
            this.uploadedFiles = [].concat(x)
            this.currentStatus = STATUS_SUCCESS
          })
          .catch(err => {
            this.uploadError = err.response
            this.currentStatus = STATUS_FAILED
          })
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name)
          });

      // save it
      this.save(formData)
    },
  },
  mounted() {
    this.reset()
  },
}
</script>

<style lang="scss" scoped>
  .field {
    a {
      color: #ffffff;
      font-weight: bold;
    }
  }
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>
